import React, {Component} from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import {StateWrapper} from '../form-validator';

/**
 * Card number field for Bootstrap Material design.
 * Shows icons for supported credit/debit payment methods
 *
 */
class CardNumberField extends Component {
    render() {
        // Note that validations is not used here directly,
        // But we have to reference it, so rest does not have.
        // We could have removed it with delete statements also.
        const {
                // 
                name, type, placeholder, description,
                className, labelClass,
                rightSideSpanClass, acceptedCards,
                // extract validations so it does not go into rest
                validations,
                // These values are injected by StateWrapper
                value, onChange, onBlur, validationState,
                ...rest
            } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        return (
            <div className={className}>
                <input
                    type={type || 'text'}
                    name={name}
                    className={classNames("form-control", {'is-invalid': hasError})}
                    id={name}
                    value={value || ''}
                    placeholder={placeholder}
                    onChange={onChange}
                    onBlur={onBlur}
                    aria-describedby={"sr-" + name}
                    aria-invalid={hasError}
                    {...rest}
                />
                <label htmlFor={name} className={classNames({"active": placeholder || value}, labelClass)}>
                    {typeof description === 'function' ? description() : description}
                </label>
                {rightSideSpanClass && <span className={rightSideSpanClass}></span>}
                {acceptedCards && <DisplayAcceptedCards acceptedCards={acceptedCards} />}
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

const DisplayAcceptedCards = (props) => {
    return props.acceptedCards.map((item, index) => (
        <span key={"pmIcon-" + index} className={classNames("pm-accepted-cards pm-icon", item)}/>
    ));
};

CardNumberField.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ]),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default StateWrapper(CardNumberField);